
/**
 * src/web/components/kpi-page.jsx
 * KPI進捗状況のTOPページ（現在のKPIと終了したKPIの一覧）
 */

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/kpi-page'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import {
  Button
} from 'react-toolbox/lib/button'
import Loading from './loading.jsx'
import RightSidePage from './right-side-page.jsx'
import { formatNumber } from '../../helpers/format-number'
import successButtonTheme from './themes/success-button.css'
import kpiTheme from './themes/kpi.css'
import newUserBadge from './themes/new-badge.css'
import moment from 'moment'
import Circle from 'react-circle'

function formatKpi(kpi, t) {
  var assignedMembers
  if (kpi.assignments.length == 0)
    assignedMembers = t('label:割り当てられていません')
  else
    assignedMembers = kpi.assignments.slice(0, 3).map((assignment)=> assignment.name).join(',')
  if (kpi.assignments.length > 3)
    assignedMembers += '... ' + t('label:他n人', { n: kpi.assignments.length - 3})

  const dateRange = `${moment(kpi.start_date).format('llll')} - ${moment(kpi.end_date).format('llll')}`
  const targetNum = formatNumber(kpi.target, kpi.display_format)

  return `${dateRange}, ${t('label:目標値', { value: targetNum })}, ${t('label:担当者', { assignments: assignedMembers })}`
}

class KPIPage extends React.Component {
  
  componentDidUpdate(prevProps) {
    if(!this.props.closedKpis && prevProps.closedKpis){
      this.props.updateUI({ showClosedKpi: false })
      this.rightSidePage && this.rightSidePage.scrollTo()
    }else{
      this.props.scrollPosition && this.rightSidePage && this.rightSidePage.scrollTo(this.props.scrollPosition)
    }
  }

  openKPIChartPage = (props, kpi_id, closedKpis)=> {
    const offset = this.rightSidePage.kpiScrollPosition()
    this.props.openKPIChartPage(props, kpi_id, closedKpis, offset)
  }

  render() {
    const {
      t,
      ui,
      kpis,
      group,
      closedKpis,
      isFetching,
      isFetchFailed,
      hasMoreClosedKpis,
      scrollPosition,
      fetchKpis,
      fetchClosedKpis,
      openKPIChartPage,
      openGroupKPIPanel,
      updateUI,
    } = this.props

    return (
      <RightSidePage title={t('label:KPI進捗状況')} icon="insert_chart" innerRef={(c)=> this.rightSidePage = c}>
        {!isFetchFailed && group && group.is_admin &&
          <Button icon='add' theme={successButtonTheme} raised
            label={t('label:KPIを作成')}
            onClick={openGroupKPIPanel} />
        }
        {!isFetchFailed && 
          <List selectable>
            <ListItem caption={t('label:現在のKPI')} selectable={false} ripple={false}/>
            {isFetching && (!kpis || kpis.length == 0) && <Loading />}
            {!isFetching && (!kpis || kpis.length == 0) &&
              <ListItem caption={t('label:KPIは登録されていません')} selectable={false} ripple={false} />
            }
            {kpis && kpis.length > 0 && _.map(kpis, (kpi) =>
              <ListItem key={kpi.kpi_id}
                  theme={kpiTheme}
                  className={'kpi_name'}
                  leftIcon='insert_chart'
                  caption={kpi.name}
                  legend={formatKpi(kpi, t)}
                  onClick={()=> openKPIChartPage(this.props, kpi.kpi_id)}
                  rightActions={[
                    kpi && kpi.accumulated_total && kpi.total / kpi.target >= 1.0 && isFinite(kpi.total / kpi.target) &&
                      <div key={kpi.kpi_id} className={newUserBadge.kpi}>{t('label:達成')}</div>,
                    kpi.accumulated_total && kpi.target && kpi.target != 0 &&
                      <Circle key={kpi.kpi_id}
                        size='60'
                        lineWidth="45"
                        textStyle={{font: 'bold 7rem Helvetica, Arial, sans-serif'}}
                        progress={Math.round(kpi.total / kpi.target * 100)} />
                      || undefined
                    ]} />
            )}

            <ListItem caption={t('label:終了したKPI')}
                selectable={true}
                rightIcon={ui.showClosedKpi && "arrow_drop_up" || "arrow_drop_down"}
                onClick={()=> {
                  !ui.showClosedKpi && fetchClosedKpis(this.props, true)
                  updateUI({ showClosedKpi: !ui.showClosedKpi })
                }} />
            {isFetching && kpis && kpis.length > 0 &&
            ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) && <Loading />}
            {!isFetching && ui.showClosedKpi && (!closedKpis || closedKpis.length == 0) &&
                <ListItem caption={t('label:KPIは登録されていません')} selectable={false} ripple={false} />
            }
            {ui.showClosedKpi && closedKpis && closedKpis.length > 0 && _.map(closedKpis, (kpi) =>
              <ListItem key={kpi.kpi_id}
                  theme={kpiTheme}
                  className={'kpi_name'}
                  leftIcon='insert_chart'
                  caption={kpi.name}
                  legend={formatKpi(kpi, t)}
                  onClick={()=> this.openKPIChartPage(this.props, kpi.kpi_id, closedKpis)}
                  rightActions={[
                    kpi && kpi.accumulated_total && kpi.total / kpi.target >= 1.0 && isFinite(kpi.total / kpi.target) &&
                      <div key={kpi.kpi_id} className={newUserBadge.kpi}>{t('label:達成')}</div>,
                    kpi.accumulated_total && kpi.target && kpi.target != 0 &&
                      <Circle key={kpi.kpi_id}
                        size='60'
                        lineWidth="45"
                        textStyle={{font: 'bold 7rem Helvetica, Arial, sans-serif'}}
                        progress={Math.round(kpi.total / kpi.target * 100)} />
                      || undefined
                    ]} />
            )}
            {!isFetching && ui.showClosedKpi && closedKpis && closedKpis.length > 0 && hasMoreClosedKpis &&
                <ListItem selectable={false} ripple={false} rightActions={[
                  <Button flat key="more" icon="arrow_drop_down"
                      label={t('label:続きを表示')}
                      onClick={()=> fetchClosedKpis(this.props)} />
                ]} />
            }
          </List>
        }
        {isFetchFailed &&
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:KPIの取得に失敗しました')}</div>
        }
      </RightSidePage> 
    )
  }
}

export const RawKPIPage = KPIPage
export default connect(KPIPage)



// WEBPACK FOOTER //
// ./src/web/components/kpi-page.jsx